import LOCALES from '../constants/locale';

const APP_SUPPORTED_LANUGAGES = {
  DISTIMAN: ['en', 'hi', 'ar', 'fa', 'bn', 'kn', 'ml', 'mr', 'ur'],
  STONESLANE: ['en', 'ar'],
};

export const getSupportedLocalesByApp = () => {
  const APP_NAME = process.env?.REACT_APP_RETAILER_APP_APP_NAME;

  const supportedLanguages = APP_SUPPORTED_LANUGAGES[APP_NAME] || APP_SUPPORTED_LANUGAGES['DISTIMAN'];

  const supportedLocales = [];
  supportedLanguages.forEach(supportedLanguage => {
    LOCALES.forEach(LOCALE => {
      if(LOCALE[0] === supportedLanguage)
        supportedLocales.push(LOCALE);
    });
  });

  return supportedLocales;
};